import { useApiClient } from '../client.js'

export const STRIPE_READERS = '/core/v2/business_api/me/businesses/{businessId}/stripe/readers'

export function getStripeReaders (businessId) {
  const apiClient = useApiClient()

  return apiClient.get({
    url: STRIPE_READERS,
    urlParams: {
      businessId,
    },
  })
}
